<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1100"
      :mask-closable="false"
      title="运营商套餐统计"
    >
      <template slot="footer">
        <a-button class="ant-btn-primary" @click="closeModal">
          关闭
        </a-button>
      </template>

      <base-carrier-product-search @submit="submitSearch" />

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        row-key="id"
      />

      <a-row class="count-tips">
        共 {{ this.tableData.length }} 条记录
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findRelativeCarrierProducts } from '@/api/base_carrier_product'
import BaseCarrierProductSearch from '@/views/base_carrier_products/statistics/Search'

export default {
  name: 'BaseCarrierProductStatistics',
  components: { BaseCarrierProductSearch },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      query: {},
      submitting: false,
      tableColumns: [
        {
          title: '运营商套餐名称',
          dataIndex: 'name'
        },
        {
          title: '运营商账户',
          width: 120,
          dataIndex: 'carrier_account_name'
        },
        {
          title: '套餐价格',
          width: 80,
          dataIndex: 'price'
        },
        {
          title: '超额资费',
          width: 150,
          dataIndex: 'excess_price'
        },
        {
          title: '划拨卡数(不含销卡)',
          width: 150,
          dataIndex: 'cards_count'
        },
        {
          title: '库存卡数',
          width: 150,
          dataIndex: 'inventory_cards_count'
        }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      findRelativeCarrierProducts(Object.assign({ id: this.id }, this.query)).then((res) => {
        this.tableData = res.data
        this.loading = false
      })
    },

    submitSearch(search) {
      this.query = search
      this.fetchData()
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.count-tips {
  padding-top: 20px;
}
</style>
